<template>
    <dashboard-layout title="찜한 공고 관리" fullHeight>
        <template slot="contents">
            <!-- 찜한 공고 관리 리스트 -->
            <template v-if="items.length">
                <div class="applied-cards">
                    <v-card rounded="lg" outlined v-for="item in items" :key="item._id" class="applied-card">
                        <v-row no-gutters>
                            <v-col cols="12" md="auto" class="border-md-end min-w-md-200px min-w-lg-280px">
                                <v-layout justify-center align-center class="w-100 h-100 pa-20">
                                    <v-img :aspect-ratio="166 / 36" width="166" height="36" max-width="166" contain :src="item?.recruitment?.company?.logo?.url">
                                        <v-fade-transition>
                                            <v-overlay v-show="!item?.recruitment?.company?.logo?.url" absolute light color="white">
                                                <image-overlay>{{ item?.recruitment?.company?.name }}</image-overlay>
                                                <!-- <v-layout row align-center class="black--text">
                                                    <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                                    <span> {{ item?.recruitment?.company?.name }} </span>
                                                </v-layout> -->
                                            </v-overlay>
                                        </v-fade-transition>
                                    </v-img>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="" class="applied-card__info">
                                <div class="pa-20 pa-md-24">
                                    <p class="page-text page-text--sm primary--text mb-4">{{ item?.recruitment?.company?.name }}</p>
                                    <div class="mb-8 mb-lg-16">
                                        <v-row no-gutters align="center" class="row--x-small">
                                            <v-col cols="auto">
                                                <a :href="`/recruitments/${item?.recruitment?._id}`" rel="noopener noreferrer" class="page-text--lg font-wieght-medium">
                                                    {{ item?.recruitment?.subject }}
                                                </a>
                                            </v-col>
                                            <v-col cols="auto">
                                                <like-btn :params="{ _recruitment: item._recruitment, type: USER_LIKE_TYPES.RECRUITMENT.value }" @removed="remove(item)">
                                                    <template #activator="{ active, toggle }">
                                                        <v-btn icon text small :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                                            <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                </like-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <v-chip-group v-if="item?.recruitment?.employment?.typesTexts" class="mb-4">
                                        <v-chip v-for="text in item.recruitment.employment.typesTexts" :key="text" small outlined color="grey-d">
                                            <span class="grey-6--text">
                                                {{ text }}
                                            </span>
                                        </v-chip>
                                    </v-chip-group>
                                    <p class="page-text grey-6--text ellip mb-8 mb-lg-16">
                                        {{ item?.recruitment?.summary }}
                                    </p>
                                    <recruitment-view-application :application="item?.recruitment?.application" />
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 사용자님. <br />
                        찜한 공고가 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 보러가기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
    <!-- <v-layout column justify-center>
        <v-card-text class="fill-height pb-0 pxy-60" style="overflow: auto">
            <template v-if="items.length">
                <v-card v-for="item in items" :key="item._id" outlined rounded="xl" class="mb-24">
                    <v-row align="center" class="ma-0">
                        <v-col cols="auto" class="px-lg-58 px-38">
                            <v-img width="166" height="36" :src="item?.recruitment?.company?.logo?.url">
                                <v-fade-transition>
                                    <v-overlay v-show="!item?.recruitment?.company?.logo?.url" absolute light color="white">
                                        <v-layout row align-center class="black--text">
                                            <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                            <span> {{ item?.recruitment?.company?.name }} </span>
                                        </v-layout>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-img>
                        </v-col>
                        <v-col cols="auto" class="align-self-stretch pa-0"> <v-divider vertical /> </v-col>
                        <v-col class="pa-24">
                            <v-card-subtitle class="pa-0 primary--text page-text--sm">{{ item?.recruitment?.company?.name }}</v-card-subtitle>
                            <v-card-title class="pa-0">
                                {{ item?.recruitment?.subject }}
                                <like-btn :params="{ _recruitment: item._recruitment, type: USER_LIKE_TYPES.RECRUITMENT.value }" @removed="remove(item)">
                                    <template #activator="{ active, toggle }">
                                        <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                            <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                        </v-btn>
                                    </template>
                                </like-btn>
                            </v-card-title>
                            <v-card-text class="pa-0 mt-16">
                                <v-chip-group v-if="item?.recruitment?.employment?.typesTexts">
                                    <v-chip v-for="text in item.recruitment.employment.typesTexts" :key="text" small outlined> {{ text }} </v-chip>
                                </v-chip-group>
                                <div class="mt-4 font-size-16">{{ item?.recruitment?.summary }}</div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-16"> <recruitment-view-application :application="item?.recruitment?.application" /> </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="text-center text-h4 font-weight-bold" style="height: calc(100% - 50px - 16px); line-height: 1.4">
                    안녕하세요, 사용자님. <br />
                    지원한 채용공고가 없습니다.
                    <v-btn x-large color="primary" class="my-24" href="/recruitments"> 채용공고 보러가기 </v-btn>
                </v-layout>
            </template>
        </v-card-text>
    </v-layout> -->
</template>

<script>
import api from "@/api";
import { USER_LIKE_TYPES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import LikeBtn from "@/components/client/like/like-btn.vue";
import RecruitmentViewApplication from "@/components/client/recruitments/view/recruitment-view-application.vue";
import ImageOverlay from "@/components/dumb/image-overlay.vue";

export default {
    components: {
        DashboardLayout,
        LikeBtn,
        RecruitmentViewApplication,
        ImageOverlay,
    },
    data: () => ({
        likes: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        USER_LIKE_TYPES,
    }),
    computed: {
        items() {
            return this.likes.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query, type: USER_LIKE_TYPES.RECRUITMENT.value, withPopulate: true };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, likes } = await api.v1.me.likes.gets({
                    headers: { skip, limit },
                    params,
                });

                this.likes = likes;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        remove(item) {
            this.likes = this.likes.filter(({ _id }) => _id != item?._id);
        },
    },
};
</script>

<style></style>
